// /* ats — Gift Cart Slider With Snackbar + Confetti */
(function () {
  class AtsGiftCartSlider {
    constructor() {
      this._skipNextSync = false;
      this._giftsManuallyRemoved = false;
      this._celebratedDiscountTiers = new Set();
      this._discountCelebrationsReady = false;

      document.addEventListener('cart:updated', e => {
        if (e?.detail?.cart) this.onCartUpdated(e.detail.cart);
      });

      document.addEventListener('click', e => {
        if (e.target.closest('[data-ats-gift-remove-all]')) {
          this.removeAllGifts();
        }
      });
    }

    async fetchCart() {
      return fetch('/cart.js').then(r => r.json());
    }

    async post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
    }

    dispatchCartEvents(cart) {
      ['cart:updated', 'cart:refresh', 'cart:build'].forEach(name => {
        document.dispatchEvent(new CustomEvent(name, { detail: { cart } }));
      });
    }

    getRoot() {
      return (
        document.querySelector('#confetti-cart-drawer [data-ats-cart-gift]') ||
        document.querySelector('.ats-freebieProgressbarWrapper [data-ats-cart-gift]') ||
        document.querySelector('[data-ats-cart-gift]')
      );
    }

    getConfig(root) {
      let raw = [];

      try {
        raw = JSON.parse(
          root.querySelector('[data-ats-cart-gift-json]')?.textContent || '[]'
        );
      } catch (_) {}

      return {
        tiers: raw
          .filter(t => {
            if (!(t?.amount > 0)) return false;
            const rewardType = t.reward_type || 'free_product';
            if (rewardType === 'order_discount') {
              return Number(t.discount_amount) > 0;
            }
            return !!t?.variant_id;
          })
          .map(t => ({
            key: String(t.key),
            label: String(t.label || ''),
            rewardType: t.reward_type || 'free_product',
            discountAmount: Number(t.discount_amount || 0),
            variantId: t.variant_id ? Number(t.variant_id) : null,
            thresholdAmountCents: Math.round(Number(t.amount) * 100),
            progressAmountCents: Math.round(Number(t.progress_amount || t.amount) * 100)
          }))
          .sort((a, b) => a.progressAmountCents - b.progressAmountCents),

        moneyFormat: root.dataset.moneyFormat || 'Rs.{{amount}}',
        msgLocked: root.dataset.msgLocked || '',
        msgUnlocked: root.dataset.msgUnlocked || '',
        msgComplete: root.dataset.msgComplete || '',
        giftMode: root.dataset.giftMode || 'stack'
      };
    }

    isGiftItem(item) {
      return item?.properties?._ats_gift;
    }

    paidSubtotalCents(cart) {
      return (cart.items || []).reduce((sum, item) => {
        return this.isGiftItem(item)
          ? sum
          : sum + (item.final_line_price || item.line_price || 0);
      }, 0);
    }

    formatMoney(format, cents) {
      return format.replace('{{amount}}', (cents / 100).toFixed(2));
    }

    async removeAllGifts() {
      const cart = await this.fetchCart();
      const updates = {};

      cart.items.forEach(item => {
        if (this.isGiftItem(item)) updates[item.key] = 0;
      });

      if (!Object.keys(updates).length) return;

      this._giftsManuallyRemoved = true;
this._skipNextSync = true;

      await this.post('/cart/update.js', { updates });

      const fresh = await this.fetchCart();
      const root = this.getRoot();

      if (root) {
        root.querySelector('[data-ats-cart-gift-fill]')?.style.setProperty('width', '0%');

        const msgMain = root.querySelector('[data-ats-cart-gift-msg-main]');
        const msgSub = root.querySelector('[data-ats-cart-gift-msg-sub]');

        if (msgMain) msgMain.textContent = 'Free gifts removed';
        if (msgSub) msgSub.textContent = '';
      }

      this.dispatchCartEvents(fresh);
    }

    showGiftSnackbar(message) {
      const root = this.getRoot();
      const snackbar =
        root?.querySelector('[data-ats-gift-snackbar]') ||
        document.querySelector('[data-ats-gift-snackbar]');

      if (!snackbar) return;

      snackbar.textContent = message || '🎉 Free gift added to your cart!';
      snackbar.classList.add('is-visible');

      clearTimeout(this._snackbarTimer);
      this._snackbarTimer = setTimeout(() => {
        snackbar.classList.remove('is-visible');
      }, 3000);
    }

    createConfetti() {
      const colors = [
        '#ff4d4d', '#ffd93d', '#6bff95', '#4d96ff', '#c77dff',
        '#ff8fab', '#ffffff', '#ff9f1c', '#2ec4b6'
      ];

      for (let i = 0; i < 120; i++) {
        const el = document.createElement('div');
        const duration = Math.random() * 1.8 + 1.4;
        const delay = Math.random() * 0.35;

        el.className = 'ats-confetti';
        el.style.left = Math.random() * 100 + 'vw';
        el.style.width = Math.random() * 8 + 4 + 'px';
        el.style.height = Math.random() * 14 + 6 + 'px';
        el.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        el.style.animationDuration = duration + 's';
        el.style.animationDelay = delay + 's';
        el.style.borderRadius = Math.random() > 0.7 ? '50%' : Math.random() > 0.45 ? '3px' : '0';

        el.style.setProperty('--ats-drift', Math.random() * 240 - 120 + 'px');
        el.style.setProperty('--ats-rotate', (Math.random() * 720 + 180) * (Math.random() > 0.5 ? 1 : -1) + 'deg');

        document.body.appendChild(el);
        setTimeout(() => el.remove(), (duration + delay) * 1000);
      }
    }

    showGiftCelebration(productName) {
      this.showRewardCelebration(
        productName
          ? `🎉 ${productName} added as a free gift!`
          : '🎉 Free gift added to your cart!'
      );
    }

    showRewardCelebration(message) {
      this.showGiftSnackbar(message);
      this.createConfetti();
    }

    discountCelebrationMessage(tier) {
      if (tier.discountAmount > 0) {
        return `🎉 You've unlocked ₹${tier.discountAmount} off!`;
      }
    
      return `🎉 You've unlocked ${tier.label || 'a reward'}!`;
    }

    getOverallHighestTier(achieved) {
      return achieved.at(-1) || null;
    }

    getActiveProductTiers(cfg, achieved) {
      const products = achieved.filter(
        t => t.rewardType !== 'order_discount' && t.variantId
      );

      if (cfg.giftMode === 'highest') {
        const overall = this.getOverallHighestTier(achieved);

        if (overall?.rewardType === 'order_discount') {
          return [];
        }

        if (overall?.variantId) {
          return [overall];
        }

        return products.length ? [products.at(-1)] : [];
      }

      return products;
    }

    getActiveDiscountTiers(cfg, achieved) {
      const discounts = achieved.filter(t => t.rewardType === 'order_discount');

      if (cfg.giftMode === 'highest') {
        const overall = this.getOverallHighestTier(achieved);

        if (overall?.rewardType === 'order_discount') {
          return [overall];
        }

        return [];
      }

      return discounts;
    }

    syncDiscountCelebrations(cfg, cart) {
      const paid = this.paidSubtotalCents(cart);
      const achieved = cfg.tiers.filter(t => paid >= t.thresholdAmountCents);
      const activeDiscountTiers = this.getActiveDiscountTiers(cfg, achieved);
      const activeKeys = new Set(
        activeDiscountTiers.map(t => String(t.thresholdAmountCents))
      );

      if (!this._discountCelebrationsReady) {
        this._discountCelebrationsReady = true;
      }

      for (const key of [...this._celebratedDiscountTiers]) {
        if (!activeKeys.has(key)) {
          this._celebratedDiscountTiers.delete(key);
        }
      }

      for (const tier of activeDiscountTiers) {
        const key = String(tier.thresholdAmountCents);

        if (!this._celebratedDiscountTiers.has(key)) {
          this._celebratedDiscountTiers.add(key);
          this.showRewardCelebration(this.discountCelebrationMessage(tier));
        }
      }
    }

    updateUI(root, cfg, cart) {
      const paid = this.paidSubtotalCents(cart);
      const max = cfg.tiers.at(-1)?.progressAmountCents || 1;
      const items = cart.items || [];
      const isCartEmpty = !items.length;
      const achieved = cfg.tiers.filter(t => paid >= t.thresholdAmountCents);

      const fill = root.querySelector('[data-ats-cart-gift-fill]');
      const msgMain = root.querySelector('[data-ats-cart-gift-msg-main]');
      const msgSub = root.querySelector('[data-ats-cart-gift-msg-sub]');
      const markers = root.querySelector('[data-ats-cart-gift-markers]');
      const labels = root.querySelector('[data-ats-cart-gift-labels]');

      const hasGift = items.some(i => this.isGiftItem(i));
      const hasUnlockedReward = achieved.length > 0;
      const firstTier = cfg.tiers[0];

      if (this._giftsManuallyRemoved && !hasGift && achieved.length === 0) {
  if (fill) fill.style.width = '0%';

  if (msgMain) {
    msgMain.textContent = 'Free gifts removed';
    msgMain.style.display = '';
  }

  if (msgSub) {
    msgSub.textContent = '';
    msgSub.style.display = 'none';
  }

  return;
}

      let pct = Math.min(100, (paid / max) * 100);

      if (
        firstTier &&
        paid >= firstTier.thresholdAmountCents
      ) {
        pct = Math.max(pct, Math.min(100, (firstTier.progressAmountCents / max) * 100));
      }

      if (fill) fill.style.width = isCartEmpty ? '0%' : pct + '%';

      if (markers) markers.innerHTML = '';
      if (labels) labels.innerHTML = '';

      cfg.tiers.forEach(t => {
        const left = (t.progressAmountCents / max) * 100;
        const unlocked = paid >= t.thresholdAmountCents;
        const amountStr = this.formatMoney(cfg.moneyFormat, t.progressAmountCents);

        if (markers) {
          markers.insertAdjacentHTML('beforeend', `
            <span class="ats-cartGift__milestone" style="left:${left}%;opacity:${unlocked ? 1 : .85}">
              <span class="ats-cartGift__milestone-amount">${amountStr}</span>
              <span class="ats-cartGift__marker">
                <svg style="width:var(--ats-progressbar-icon-size);height:var(--ats-progressbar-icon-size);" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                  <path d="M32 10.015c0-1.104-0.895-2-2-2h-3.414c0.884-0.872 1.449-2.014 1.449-3.421 0-1.732-0.995-3.615-3.788-3.615-3.675 0-6.745 3.913-8.188 6.106-1.444-2.193-4.607-6.106-8.282-6.106-2.793 0-3.788 1.882-3.788 3.614 0 1.407 0.581 2.55 1.482 3.421h-3.472c-1.105 0-2 0.896-2 2v5.986h2.018v13.017c0 1.105 0.895 2 2 2h23.99c1.105 0 2-0.895 2-2v-13.018h1.992v-5.986zM24.247 2.981c1.236 0 1.788 0.52 1.788 1.615 0 2.221-2.479 3.42-4.811 3.42h-3.386c1.421-2.111 3.922-5.035 6.409-5.035zM7.778 2.981c2.487 0 5.083 2.924 6.504 5.034h-3.386c-2.332 0-4.905-1.229-4.905-3.451 0-1.095 0.551-1.583 1.788-1.583zM30 14.002h-13v-3.986h13v3.986zM2 10.015h13v3.986h-13zM4.018 16.002h10.982v13.018h-10.982zM28.008 29.020h-11.008v-13.017h11.008v13.017z"
                    fill="var(--ats-progressbar-icon-color)"
                    stroke="var(--ats-progressbar-icon-color)">
                  </path>
                </svg>
              </span>
            </span>
          `);
        }

        if (labels) {
          const label = document.createElement('span');
          label.className = 'ats-cartGift__label';
          label.style.left = left + '%';
          label.style.whiteSpace = 'pre-line';
          label.textContent = t.label;
          labels.appendChild(label);
        }
      });

      if (isCartEmpty) {
        if (msgMain) {
          msgMain.textContent = 'Add items in cart to unlock discounts';
          msgMain.style.display = '';
        }

        if (msgSub) {
          msgSub.textContent = '';
          msgSub.style.display = 'none';
        }

        return;
      }

      const next = cfg.tiers.find(t => paid < t.thresholdAmountCents);

      if (!next) {
        if (msgMain) {
          msgMain.textContent = cfg.msgComplete || 'All gifts unlocked!';
          msgMain.style.display = '';
        }

        if (msgSub) {
          msgSub.textContent = '';
          msgSub.style.display = 'none';
        }

        return;
      }

      const amountStr = this.formatMoney(cfg.moneyFormat, next.thresholdAmountCents - paid);

      if (msgMain) {
        msgMain.textContent = hasUnlockedReward
          ? cfg.msgUnlocked || 'Congratulations! You’ve unlocked a free gift 🎉'
          : '';

        msgMain.style.display = hasUnlockedReward ? '' : 'none';
      }

      if (msgSub) {
        msgSub.textContent =
          cfg.msgLocked.replace('{{amount}}', amountStr) ||
          `Add ${amountStr} more to unlock gift`;

        msgSub.style.display = '';
      }
    }

    async syncGifts(cfg, cart) {
      if (this._skipNextSync) {
        this._skipNextSync = false;
        return false;
      }

      const paid = this.paidSubtotalCents(cart);
      const achieved = cfg.tiers.filter(t => paid >= t.thresholdAmountCents);
      const productTiers = this.getActiveProductTiers(cfg, achieved);
      const desiredIds = new Set(productTiers.map(t => t.variantId));

      const items = cart.items || [];
      const gifts = items.filter(i => this.isGiftItem(i));
      const existingGiftIds = new Set(gifts.map(i => i.variant_id));

      let changed = false;
      let addedGiftName = '';

      for (const item of gifts) {
        if (!desiredIds.has(item.variant_id)) {
          await this.post('/cart/change.js', {
            id: item.key,
            quantity: 0
          });

          changed = true;
        }
      }

      const tiersToAdd = productTiers;

      for (const tier of tiersToAdd) {
        if (!existingGiftIds.has(tier.variantId)) {
          await this.post('/cart/add.js', {
            id: tier.variantId,
            quantity: 1,
            properties: { _ats_gift: '1' }
          });

          changed = true;

          const fresh = await this.fetchCart();
          const added = fresh.items.find(i => {
            return i.variant_id === tier.variantId && this.isGiftItem(i);
          });

          addedGiftName = added?.product_title || added?.title || 'Free gift';
        }
      }

      if (addedGiftName) this.showGiftCelebration(addedGiftName);

      return changed;
    }

    async onCartUpdated(cart) {
      const root = this.getRoot();
      if (!root) return;

      const cfg = this.getConfig(root);
      if (!cfg.tiers.length) return;

      this.updateUI(root, cfg, cart);
      this.syncDiscountCelebrations(cfg, cart);

      if (await this.syncGifts(cfg, cart)) {
        const fresh = await this.fetchCart();

        this.updateUI(root, cfg, fresh);
        this.dispatchCartEvents(fresh);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', async () => {
    window.ats = window.ats || {};

    if (!window.ats.giftSlider) {
      window.ats.giftSlider = new AtsGiftCartSlider();
    }

    window.ats.giftSlider.onCartUpdated(
      await window.ats.giftSlider.fetchCart()
    );
  });
})();

